import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const usePatientDeaspCertificates = ({
  patientId,
  page = 1,
  rows = 10,
  enabled = true,
}) => {
  const tenant = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["patientDeaspCertificates", tenant, patientId, page, rows],
    enabled: enabled && !!patientId && !!tenant,
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenant}/healthlink/deasp-form/patients/${patientId}`,
        { params: { page, rows } }
      );

      return response.data;
    },
  });
};
